import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormGroup } from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate, parseDate } from 'react-day-picker/moment';
import styled, { css } from 'styled-components';
import { prop, ifProp } from 'styled-tools';
import DayPickerWrapper from 'routes/DateSelection/components/styled/DayPickerWrapper';
import DayPickerNavbar from 'routes/DateSelection/components/DayPickerNavbar';
import LargestCol from 'components/LargestCol';
import FormLabel from './styled/FormLabel';
import { GUEST_INFORMATION_PATH, REVIEW_SUBMIT_PATH } from 'utils/constants';
import { getBookingEnginePath } from 'utils/routeUtils';

const propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  queryInput: PropTypes.shape({
    accountNumber: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    propertyCode: PropTypes.string
  }),
  isHostBooking: PropTypes.bool,
  isAdmin: PropTypes.bool
};

const defaultProps = {
  errors: [],
  isAdmin: false
};

const BookingDatesFormGroup = styled(FormGroup)`
  ${ifProp(
    'isHostBooking',
    css`
      @media screen and (max-width: ${prop('theme.breakpoints.medium')}) {
        margin: 0 0 1em 0;
      }
    `
  )}
`;

function BookingDatesForm({
  startDate,
  endDate,
  errors,
  onStartDateChange,
  onEndDateChange,
  queryInput,
  isHostBooking,
  isAdmin
}) {
  const pathName = getBookingEnginePath(window.location.pathname);
  const isGuestReviewPage =
    isAdmin &&
    (pathName === GUEST_INFORMATION_PATH || pathName === REVIEW_SUBMIT_PATH);
  return (
    <BookingDatesFormGroup isHostBooking={isHostBooking} row>
      <LargestCol md="12" lg="6">
        <FormLabel
          error={errors.length > 0 ? (!startDate).toString() : undefined}
          htmlFor="fromDate"
          isHostBooking={isHostBooking}
        >
          From
        </FormLabel>
        <DayPickerWrapper
          error={errors.length > 0 ? (!startDate).toString() : undefined}
        >
          <DayPickerInput
            value={startDate ? startDate : ''}
            onDayChange={onStartDateChange}
            formatDate={formatDate}
            parseDate={parseDate}
            placeholder={'MM/DD/YYYY'}
            dayPickerProps={{
              fromMonth: new Date(),
              disabledDays: { before: new Date() },
              navbarElement: DayPickerNavbar
            }}
            inputProps={{
              name: 'fromDate',
              autoComplete: 'off',
              disabled: isGuestReviewPage,
              id: 'fromDate'
            }}
          />
          <FontAwesomeIcon
            icon="calendar"
            aria-hidden="true"
            role="presentation"
            title="Calendar Icon"
          />
        </DayPickerWrapper>
      </LargestCol>
      <LargestCol md="12" lg="6">
        <FormLabel
          error={errors.length > 0 ? (!endDate).toString() : undefined}
          htmlFor="toDate"
          isHostBooking={isHostBooking}
        >
          To
        </FormLabel>
        <DayPickerWrapper
          error={errors.length > 0 ? (!endDate).toString() : undefined}
        >
          <DayPickerInput
            value={endDate ? endDate : ''}
            onDayChange={onEndDateChange}
            formatDate={formatDate}
            parseDate={parseDate}
            placeholder={'MM/DD/YYYY'}
            dayPickerProps={{
              month: startDate,
              fromMonth: moment(startDate).toDate(),
              disabledDays: {
                before: startDate
                  ? moment(startDate)
                      .add(1, 'day')
                      .toDate()
                  : moment()
                      .add(1, 'day')
                      .toDate()
              },
              navbarElement: DayPickerNavbar
            }}
            inputProps={{
              name: 'toDate',
              autoComplete: 'off',
              disabled: isGuestReviewPage,
              id: 'toDate'
            }}
          />
          <FontAwesomeIcon
            icon="calendar"
            aria-hidden="true"
            role="presentation"
            title="Calendar Icon"
          />
        </DayPickerWrapper>
      </LargestCol>
    </BookingDatesFormGroup>
  );
}

BookingDatesForm.propTypes = propTypes;
BookingDatesForm.defaultProps = defaultProps;

export default BookingDatesForm;
